import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import Layout from "../components/Layout";
import { api, auth } from "../lib/api";

export default function POSLogin() {
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { password: pwd });
      auth.token = r.data.token;
      navigate("/pos/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-24">
        <div className="surface p-8">
          <div
            className="w-12 h-12 flex items-center justify-center mb-6"
            style={{ background: "var(--ab-primary)", color: "var(--ab-bg)" }}
          >
            <Lock size={22} strokeWidth={2.5} />
          </div>
          <h1 className="font-display text-3xl font-black mb-2">POS Access</h1>
          <p className="text-sm mb-8" style={{ color: "var(--ab-text-muted)" }}>
            Enter your password to continue to the back-office.
          </p>
          <form onSubmit={submit}>
            <label className="label-eyebrow block mb-2">Password</label>
            <input
              type="password"
              className="input-terminal mb-4"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              autoFocus
              required
              data-testid="pos-login-password"
            />
            {error && <div className="text-sm mb-4" style={{ color: "var(--ab-danger)" }} data-testid="pos-login-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="pos-login-submit">
              {loading ? <Loader2 size={16} className="animate-spin" /> : null} Enter POS
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
